// Ant Design 主题配置 - 紧凑型设计
export const theme = {
  token: {
    // 基础令牌
    colorPrimary: '#1890ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1890ff',

    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    
    // 边框和圆角
    borderRadius: 6,
    borderRadiusXS: 2,
    borderRadiusSM: 4,
    borderRadiusLG: 8,
    
    // 间距令牌 - 紧凑型
    padding: 12,
    paddingXXS: 2,
    paddingXS: 4,
    paddingSM: 8,
    paddingMD: 12,
    paddingLG: 16,
    paddingXL: 20,
    paddingXXL: 24,
    
    // 字体令牌
    fontSize: 14,
    fontSizeXS: 11,
    fontSizeSM: 12,
    fontSizeLG: 16,
    fontSizeXL: 18,
    fontSizeHeading1: 24,
    fontSizeHeading2: 20,
    fontSizeHeading3: 18,
    fontSizeHeading4: 16,
    fontSizeHeading5: 14,
    
    // 行高
    lineHeight: 1.4,
    lineHeightLG: 1.6,
    lineHeightSM: 1.2,
    
    // 控件高度 - 紧凑型
    controlHeight: 32,
    controlHeightSM: 28,
    controlHeightLG: 36,
    controlHeightXS: 24,
    
    // 阴影
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
    boxShadowSecondary: '0 2px 4px rgba(0, 0, 0, 0.08)',
    boxShadowTertiary: '0 4px 8px rgba(0, 0, 0, 0.12)',
    
    // 动画
    motionDurationFast: '0.1s',
    motionDurationMid: '0.2s',
    motionDurationSlow: '0.3s',
  },
  
  components: {
    // Card 组件
    Card: {
      paddingLG: 12,
      paddingSM: 8,
      headerBg: 'transparent',
      headerHeight: 'auto',
      headerHeightSM: 'auto',
    },
    
    // Button 组件
    Button: {
      paddingContentHorizontal: 12,
      paddingContentHorizontalSM: 8,
      paddingContentHorizontalLG: 16,
      fontWeight: 400,
    },
    
    // List 组件
    List: {
      paddingLG: 12,
      paddingSM: 8,
      paddingXS: 4,
    },
    
    // Form 组件
    Form: {
      itemMarginBottom: 12,
      verticalLabelPadding: '0 0 4px',
      labelHeight: 'auto',
    },
    
    // Input 组件
    Input: {
      paddingBlock: 4,
      paddingInline: 8,
    },
    
    // Table 组件
    Table: {
      paddingContentVerticalLG: 8,
      paddingContentVertical: 6,
      paddingContentVerticalSM: 4,
      cellPaddingBlock: 6,
      cellPaddingInline: 12,
      cellPaddingBlockSM: 4,
      cellPaddingInlineSM: 8,
    },
    
    // Menu 组件
    Menu: {
      itemHeight: 40,
      itemPaddingInline: 12,
      subMenuItemBg: 'transparent',
      itemBg: 'transparent',
    },
    
    // Drawer 组件
    Drawer: {
      paddingLG: 16,
      padding: 12,
    },
    
    // Modal 组件
    Modal: {
      paddingLG: 16,
      padding: 12,
      paddingContentHorizontalLG: 16,
      paddingMD: 12,
    },
    
    // Tabs 组件
    Tabs: {
      cardPaddingSM: 8,
      cardPadding: 12,
      horizontalItemPadding: '8px 12px',
      horizontalItemPaddingSM: '6px 8px',
    },
    
    // Badge 组件
    Badge: {
      indicatorHeight: 16,
      indicatorHeightSM: 14,
      dotSize: 6,
    },
    
    // Tag 组件
    Tag: {
      paddingInline: 4,
      paddingInlineSM: 2,
      defaultBg: '#f5f5f5',
    },
    
    // Pagination 组件
    Pagination: {
      itemSize: 28,
      itemSizeSM: 24,
      miniOptionsSizeChangerTop: 0,
    },
    
    // Steps 组件
    Steps: {
      // 使用像素值的行高，避免 PC 端中文标题被裁切
      titleLineHeight: 22,
      descriptionMaxWidth: 140,
    },
    
    // Alert 组件
    Alert: {
      paddingContentVerticalSM: 6,
      paddingContentHorizontalSM: 8,
      withDescriptionPaddingVertical: 8,
    },
    
    // Tooltip 组件
    Tooltip: {
      paddingXXS: 4,
      paddingXS: 6,
    },
    
    // Popover 组件
    Popover: {
      titleMinWidth: 120,
      innerPadding: 8,
    },
    
    // Select 组件
    Select: {
      optionPadding: '4px 8px',
      optionSelectedBg: '#e6f7ff',
    },
    
    // DatePicker 组件
    DatePicker: {
      cellHeight: 28,
      cellWidth: 32,
      textHeight: 28,
    },
    
    // Switch 组件
    Switch: {
      trackHeight: 20,
      trackHeightSM: 16,
      trackMinWidth: 40,
      trackMinWidthSM: 28,
    },
    
    // Slider 组件
    Slider: {
      trackBg: '#f5f5f5',
      trackHoverBg: '#e6f7ff',
      dotSize: 8,
      dotActiveBorderWidth: 2,
    },
    
    // Progress 组件
    Progress: {
      defaultColor: '#1890ff',
      remainingColor: '#f5f5f5',
      circleTextFontSize: '0.8em',
    },
    
    // Rate 组件
    Rate: {
      starSize: 16,
      starSizeSM: 14,
    },
    
    // Upload 组件
    Upload: {
      actionsColor: '#595959',
    },
    
    // Anchor 组件
    Anchor: {
      linkPaddingBlock: 4,
      linkPaddingInlineStart: 12,
    },
    
    // BackTop 组件
    BackTop: {
      zIndexPopup: 1000,
    },
    
    // Affix 组件
    Affix: {
      zIndexPopup: 1000,
    },
  },
};

export const PAGINATION_DEFAULT_PAGE_SIZE = 10;
export const PAGINATION_ENABLE_SIZE_CHANGER = false;
export const PAGINATION_PAGE_SIZE_OPTIONS = ['10', '20', '50', '100'];

export const LAYOUT_HEADER_HEIGHT = 64;
export const LAYOUT_SIDEBAR_WIDTH = 220;
export const LAYOUT_SIDEBAR_COLLAPSED_WIDTH = 80;
export const LAYOUT_MOBILE_BOTTOM_NAV_HEIGHT = 60;

export default theme;
